import React, { useState } from 'react';

import { PurchaseStatus } from 'deposit/services/deposit-service';

import { useGetToken, useWindowOpener } from './hooks';

export interface ExternalRedirectionContextType {
  useCatchWindow: (tab: Window) => void;
  useDelayedRedirection: (destionation: string) => void;
  useCloseTab: () => void;
  useGetTabRef: () => Window | null | undefined;
}

export const ExternalRedirectionContext = React.createContext<ExternalRedirectionContextType>(
  {} as ExternalRedirectionContextType,
);

const ExternalRedirection: React.FC = (props) => {
  const token = useGetToken();
  const [newTab, setNewTab] = useState<Window | null | undefined>();
  const { children } = props;

  const externalRedirectionContext = {
    useCatchWindow: (tab?: Window | null) => {
      setNewTab(tab);
    },
    useGetTabRef: () => {
      return newTab;
    },
    useCloseTab: () => {
      newTab && newTab.close();
    },
    useDelayedRedirection: (destination: string) => {
      if (newTab && newTab?.location.href === 'about:blank') {
        useWindowOpener(destination, newTab ?? window, PurchaseStatus.PENDING, token);
      }
    },
  };

  return (
    <ExternalRedirectionContext.Provider value={externalRedirectionContext}>
      {children}
    </ExternalRedirectionContext.Provider>
  );
};

export default ExternalRedirection;
